export function normalizeValue(x: number, min: number, max: number): number {
  if (x <= min) {
    return 0;
  }
  if (x >= max) {
    return 1;
  }
  return (x - min) / (max - min);
}
